import {
  IconAlertCircle,
  IconBuilding,
  IconCircleCheck,
  IconExternalLink,
  IconGlobe,
  IconMapPin,
  IconShare,
  IconUsers,
} from "@tabler/icons-react";
import styles from "./popup.module.css";
import CompanyAvatar from "../../../../assets/svgs/companyAvatar.svg";

const ProfileHero = ({ data }) => {
  const {
    companyName,
    companyWebsiteUrl,
    companyAddress,
    companySize,
    companyType,
    clientLogo,
    profileVerified,
  } = data;
  // const { size, type } = classData;

  const websiteHref = companyWebsiteUrl
    ? companyWebsiteUrl.startsWith("http")
      ? companyWebsiteUrl
      : "https://" + companyWebsiteUrl
    : "#";

  return (
    <div className={styles.profileHero}>
      {/* Logo */}
      <div className={styles.heroLogo} id="heroLogoContainer">
        {clientLogo ? (
          <img src={clientLogo} alt="Company logo" />
        ) : (
          <img src={CompanyAvatar} alt="Company logo" />
        )}
      </div>

      {/* Info */}
      <div className={styles.heroInfo}>
        <div className={styles.heroCompanyName}>
          {companyName || "Your Company"}
        </div>
        <div className={styles.heroMeta}>
          {/* Website */}
          {companyWebsiteUrl && (
            <a
              className={`${styles.heroMetaItem} ${styles.heroMetaLink}`}
              id="heroWebsite"
              href={websiteHref}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconGlobe size={12} />
              <span>
                {companyWebsiteUrl}
                <IconExternalLink
                  className={`${styles.heroLinkIcon}`}
                  aria-hidden="true"
                />
              </span>
            </a>
          )}

          {/* Address */}
          {companyAddress && (
            <div className={styles.heroMetaItem} id="heroAddress">
              <IconMapPin size={12} />
              <span>{companyAddress}</span>
            </div>
          )}

          {/* Employees */}
          {companySize && (
            <div className={styles.heroMetaItem} id="heroEmployees">
              <IconUsers size={12} />
              <span>{companySize}</span>
            </div>
          )}

          {/* Badges */}
          <div className={styles.heroBadges}>
            {profileVerified ? (
              <span
                className={`${styles.heroBadge} ${styles.verifiedBadge}`}
                id="heroVerifiedBadge"
              >
                <IconCircleCheck size={12} />
                Verified
              </span>
            ) : (
              <span
                className={`${styles.heroBadge} ${styles.unverifiedBadge}`}
                id="heroUnverifiedBadge"
              >
                <IconAlertCircle size={12} />
                Unverified
              </span>
            )}
            {companyType && (
              <span className={styles.heroBadge} id="heroTypeBadge">
                <IconBuilding size={12} />
                {companyType}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Actions */}
      <div className={styles.heroActions}>
        <button
          type="button"
          className={styles.btnOutline}
          onClick={async () => {
            const shareUrl = `${window.location.origin}/company-profile`;
            try {
              if (navigator.share) {
                await navigator.share({
                  title: companyName || "Company profile",
                  url: shareUrl,
                });
              } else if (navigator.clipboard?.writeText) {
                await navigator.clipboard.writeText(shareUrl);
              }
            } catch (_) {
              window.open(
                `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
                "_blank",
                "noopener,noreferrer",
              );
            }
          }}
        >
          <IconShare />
          Share
        </button>
      </div>
    </div>
  );
};

export default ProfileHero;
